import { ISelectableOption } from "../../../types";
import {
  LOADING_DEFAULT_ISelectableOption,
  NO_RESULTS_DEFAULT_ISelectableOption,
} from "../constants";

const getAutoCompleteSelectableOptions = (
  options: ISelectableOption[],
): ISelectableOption[] =>
  options.filter(
    (option) =>
      !option.disabled &&
      option.value !== "" &&
      option.label !== LOADING_DEFAULT_ISelectableOption().label &&
      option.label !== NO_RESULTS_DEFAULT_ISelectableOption().label,
  );

export const getSelectAllState = (
  options: ISelectableOption[],
  selectedValues: ISelectableOption[],
) => {
  const selectableOptions = getAutoCompleteSelectableOptions(options);
  const selectedValuesMap = new Set(
    selectedValues.map((selectedOption) => selectedOption.value),
  );
  const selectedLabelsMap = new Set(
    selectedValues.map((selectedOption) => selectedOption.label),
  );

  const isAllSelected =
    selectableOptions.length > 0 &&
    selectableOptions.every(
      (option) =>
        selectedValuesMap.has(option.value) ||
        selectedLabelsMap.has(option.label),
    );

  const isAnySelected = selectedValues.length > 0;

  return {
    selectableOptions,
    isAllSelected,
    isIndeterminate: isAnySelected && !isAllSelected,
  };
};

export const getSelectedOptionLabel = (
  option: ISelectableOption,
  selectedOptionsWithLabels: ISelectableOption[],
): string =>
  selectedOptionsWithLabels.find((selected) => selected.value === option.value)
    ?.label ?? option.label;
